import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import {
    Grid,
    Box,
    Tab,
    Tabs,
} from '@material-ui/core';

import {
    Person as PersonIcon,
    Lock as LockIcon,
    Payment as BillingIcon,
    Security as SecurityIcon,
    Error,
} from '@material-ui/icons';

import Widget from '../../../components/Widget/Widget.jsx';
import usePhoneVerificationStatus from '../../hooks/usePhoneVerificationStatus';

import { useStyles } from '../profile.styles';

const ICONS = {
    User: <PersonIcon />,
    Security: <SecurityIcon />,
    Account: <LockIcon />,
    Billing: <BillingIcon />,
};

function ProfileTabs (props) {
    const {
        onTabChange,
        tabIndex = 0,
        tabs = [],
    } = props;

    const [tab, setTab] = useState(tabIndex);
    const classes = useStyles();
    const { showErrorIcon } = usePhoneVerificationStatus();

    function handleTabChange (event, newValue) {
        setTab(newValue);
        onTabChange(newValue);
    }

    useEffect(() => {
        setTab(tabIndex);
    }, [tabIndex]);

    return (
        <Grid item xs={12}>
            <Widget>
                <Box display={'flex'} justifyContent={'center'}>
                    <Tabs
                        indicatorColor='primary'
                        textColor='primary'
                        value={tab}
                        onChange={handleTabChange}
                        aria-label='Tabs'
                    >
                        {tabs.map((tabInfo) => (
                            <Tab
                                key={tabInfo.id}
                                label={
                                    <span className={classes.tabLabelWrapper}>
                                        {tabInfo.label}
                                        {tabInfo.label === 'Security' && showErrorIcon && (
                                            <Error
                                                className={classes.statusIcon}
                                                style={{ color: '#FD1818' }}
                                            />
                                        )}
                                    </span>
                                }
                                icon={ICONS[tabInfo.label]}
                                classes={{ wrapper: classes.icon }}
                            />
                        ))}
                    </Tabs>
                </Box>
            </Widget>
        </Grid>
    );
}

ProfileTabs.propTypes = {
    onTabChange: PropTypes.func,
    tabs: PropTypes.array,
};

ProfileTabs.defaultProps = {
    onTabChange: () => {},
    tabs: [],
};

const ObservedProfileTabs = observer(ProfileTabs);
export default ObservedProfileTabs;
